export const classes = {
  dialog: 'w-[98vw] max-w-[400px] min-w-[150px]',
  body: 'w-full pt-2 pb-12 overflow-auto text-center text-grey-7 dark:text-mauve-2',
  paragraph: 'mb-4 text-base text-grey-8 dark:text-mauve-1',
};
